import { render, staticRenderFns } from "./upsell-products-sort-modal.vue?vue&type=template&id=35a6155a&scoped=true&"
import script from "./upsell-products-sort-modal.vue?vue&type=script&lang=js&"
export * from "./upsell-products-sort-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6155a",
  null
  
)

export default component.exports